import React, { memo } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { LinkIcon } from "@/assets/svg/svgIcons";
import { ROOT_PATH } from "@/config/routes";

import type { NavItemType } from "../Navbar";
interface ElementNavBarProps {
  navItem: NavItemType;
  onLinkClick?: () => void;
  open?: boolean;
  showLinkLogo?: boolean;
  toggleNavbar?: () => void;
}

const ElementNavBar: React.FC<ElementNavBarProps> = ({
  navItem,
  onLinkClick,
  open = true,
  showLinkLogo = true,
  toggleNavbar,
}) => {
  const location = useLocation();
  const isAnchor = navItem.href?.startsWith("#");
  const hasHash = !isAnchor && (navItem.href?.includes("#") ?? false);

  const stripTrailing = (s: string) => s.replace(/\/$/, "");

  const match = () => {
    if (isAnchor) return false;
    const [rawPath, rawHash] = (navItem.href ?? "").split("#");
    const targetPath = stripTrailing(rawPath || "");
    const currentPath = stripTrailing(location.pathname);
    if (hasHash) {
      return (
        targetPath === currentPath && location.hash === `#${rawHash ?? ""}`
      );
    }
    return targetPath === currentPath;
  };

  const handleLinkClick = () => {
    if (navItem.link && toggleNavbar) {
      toggleNavbar();
    }
    if (onLinkClick) {
      onLinkClick();
    }
  };

  const hilightClass = navItem.hilight ? "hilight" : "";

  if (isAnchor) {
    return (
      <li className={`nav-item ${navItem.className ?? ""} ${hilightClass}`}>
        <a href={navItem.href} className="nav-link" onClick={handleLinkClick}>
          {navItem.icon && navItem.icon}
          {open && <span className="link-text">{navItem.text}</span>}
        </a>
      </li>
    );
  }

  return (
    <li
      className={`nav-item ${navItem.className ?? ""} ${match() ? "active" : ""} ${hilightClass}`}
    >
      <NavLink
        to={navItem.href ?? navItem.link ?? ROOT_PATH}
        className={`nav-link `}
        onClick={handleLinkClick}
        aria-current="page"
        end={navItem.href === ROOT_PATH}
        target={navItem.link ? "_blank" : "_self"}
      >
        {navItem.icon && navItem.icon}
        {open && (
          <span className="link-text">
            {navItem.text}
            {navItem.link && showLinkLogo && <LinkIcon />}
          </span>
        )}
      </NavLink>
    </li>
  );
};

export default memo(ElementNavBar);
